/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import { FieldArray } from 'redux-form';
import { COMPONENT_POPULATION } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/formInputNames.js';
import render from './render/index.js';

type Props = {|
  form: string,
|};

const AddComponent = (props: Props): Element<'div'> => {
  const { form } = props;
  return (
    <div>
      <Form noValidate>
        <FieldArray form={form} name={COMPONENT_POPULATION} component={render} />
      </Form>
    </div>
  );
};

export default AddComponent;
